import { ContentWrapper } from "../styled";
import { DrawerBodyElementWrapper } from "../../../components/RightDrawer/styled";
import { Form, Row, Tabs, Input } from "antd";
import styled from "styled-components";

export const StyledTextArea = styled(Input.TextArea)`
  &.ant-input {
    line-height: 24px;
  }
`;

export const StyledTabs = styled(Tabs)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .ant-tabs-content.ant-tabs-content-top,
  .chat-wrapper {
    height: 100%;
  }

  > div:first-child {
    padding: 0 20px;

    > div > div {
      padding-left: 28px;
      padding-right: 28px;
    }
  }

  .ant-badge-count {
    background-color: ${"#1677ff"};
  }

  .chat-wrapper {
    padding: 8px 24px;

    .chat-history {
      height: calc(100% - 48px);
      padding: 20px 0 28px;
    }
  }
`;

export const InWorkWrapper = styled(ContentWrapper)`
  .comment-drawer-title {
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: ${"#434343"};
  }

  .comment-title {
    font-size: 16px;
    font-weight: 600;
  }

  .top-content-wrapper {
    margin-bottom: 24px;

    ${DrawerBodyElementWrapper}:not(:last-child) {
      margin-bottom: 6px;
    }
  }

  .bottom-content-wrapper {
    margin-bottom: 32px;

    ${DrawerBodyElementWrapper}:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;

export const CommentDrawerContentDecisionForm = styled(Form)`
  height: 100%;

  .content-decision-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .ant-radio-wrapper {
      width: 100%;
    }

    .voting-roles-wrapper .ant-form-item-control-input-content {
      display: grid;
      grid-template-columns: repeat(2, fit-content(100%));
      grid-gap: 8px;
    }
  }
`;

export const FooterButtonRow = styled(Row)`
  width: 100%;
  padding: 16px 24px;
  border-top: 1px solid ${"#f5f5f5"};
`;
